import React from 'react';
export interface DjayMeesterLogoProps {
  size?: 'sm' | 'lg' | 'xl';
  className?: string;
}
/**
 * DjayMeesterLogo — Clean typographic wordmark.
 *
 * No inline SVG character — the real DjayAvatar is shown separately
 * wherever mascot presence is needed. This keeps the logo crisp and
 * consistent with the design system.
 */
export function DjayMeesterLogo({
  size = 'sm',
  className = ''
}: DjayMeesterLogoProps) {
  const sizeClass = size === 'xl' ? 'text-5xl md:text-6xl' : size === 'lg' ? 'text-4xl md:text-5xl' : 'text-xl';
  return <div className={`inline-flex items-baseline gap-1.5 select-none ${className}`} aria-label="Meester djay" role="img" data-id="element-3442" data-mp="2hwm3d7vhaxvb">
      <span className={`font-extrabold tracking-tight text-slate-800 ${sizeClass}`} data-id="element-3443" data-mp="2cwpyl6eyj2ep">
        Meester
      </span>
      <span className={`font-extrabold italic tracking-tight text-orange-500 ${sizeClass}`} data-id="element-3444" data-mp="3tdvlnr2vfjv1">
        djay
      </span>
    </div>;
}